<template>
  <div>
    <b-modal
      id="modal-edit-pendidikan"
      size="lg"
      centered
      :title="$store.state.modal.editDataPendidikan"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.tingkatPendidikan" label-cols-md="3">
          <b-form-select :options="lampiran"></b-form-select>
        </b-form-group>

        <b-form-group :label="$store.state.form.namaSekolah" label-cols-md="3">
          <b-form-input type="text"></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.tahunKelulusan" label-cols-md="3">
          <b-form-input type="text"></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.jurusan" label-cols-md="3">
          <b-form-input type="text"></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit-pendidikan')"
        >
          {{ $store.state.form.batal }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      lampiran: [
        { value: "", text: "Lampiran 1" },
        { value: "", text: "Lampiran 2" },
      ],
    };
  },
};
</script>
